/* src/app/shared/components/ag-report/ag-report-message/ag-report-message.component.scss */
div {
  font-size: 1rem;
  border-bottom: 1px solid #c8c7cc;
  align-items: center;
  height: 50px;
}
div .report-message__title {
  padding-left: 32px;
}
div .report-message__status {
  width: 31px;
}
div .report-message__status img {
  height: 27px;
}
div .report-message__message {
  font-style: italic;
}
div .report-message__action {
  display: flex;
  justify-content: flex-end;
}
div .report-message__action a {
  padding: 6px 16px 7px;
  border-radius: 19px;
  background-color: #61566e;
  font-size: 12px;
  color: #f2eee7;
  text-decoration: none;
}
.ag-success {
  color: #578a6b;
}
.ag-info {
  color: #333333;
}
.ag-warning {
  color: #e4be5e;
}
.ag-error {
  color: #d7263c;
}
/*# sourceMappingURL=ag-report-message.component.css.map */
